var magicStyles = [".wrapper[data-v-27d2c4ac]{min-height:208px}"];

export default magicStyles;
